import { FC } from "react";
import { useTranslation } from "react-i18next";
import { email } from "../../../Config";

interface SendEmailButtonProps {
    className?: string;
}

const SendEmailButton: FC<SendEmailButtonProps> = (props) => {
    const { t } = useTranslation();

    return (
        <a
            href={`mailto:${email}`}
            target="_blank"
            rel="noreferrer"
            className={`flex justify-center items-center H16 dmax2:H14 border border-black text-[#FCFAF0] bg-black hover:text-black hover:bg-white transition-all duration-300 rounded-[3px] w-[230px] h-[45px] cursor-pointer ${props.className}`}
        >
            {t("common.sendEmail")}
        </a>
    );
};

export default SendEmailButton;
